// src/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  theRemberMe:false
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.token = action.payload.token;
      state.theRemberMe = action.payload.rememberMe;
    },
    clearUser(state) {
      state.token = null;
      state.theRemberMe = false;
    }
  }
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
